import React, { useContext } from "react";
import { TableContext } from "../index";
import { Checkbox } from "../view/Checkbox";
import { deepCopy } from "../utils";
import { MoreVertical } from 'lucide-react';
// import { getConfigActionImpactPopup } from "../view/popup/PopupContainer";
// import MenuItem from "@mui/material/MenuItem";
// import Menu from "@mui/material/Menu";
// import { parseConfigActionNote } from "./configActionNoteParser";

function normalizeUsername(value) {
    return (value || '')
        .trim()
        .replace(/^=/, '')
        .replace(/^['"]+|['"]+$/g, '')
        .replace(/^\.+|\.+$/g, '');
}

function getLoginCount(note) {
    const count = (note || '').split('=')[1];
    return count || '0';
}

// function renderMetaBadge(text, className = 'bg-light text-dark border') {
//     return (
//         <span key={text} className={`badge me-1 mb-1 ${className}`}>
//             {text}
//         </span>
//     );
// }

function MlDetectionTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    // const { setPopup } = useContext(PopupContext);
    // const [anchorEl, setAnchorEl] = useState(null);

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    // Get badge class based on result
    // const getResultBadgeClass = (result) => {
    //     if (!result) return 'oct_badge-normal-v2';
    //     const r = result.toLowerCase();
    //     if (r === 'anomaly') return 'oct_badge-anomaly-v2';
    //     if (r === 'suspicious') return 'oct_badge-anomaly-v2';
    //     if (r === 'high_risk') return 'oct_badge-anomaly-v2';
    //     if (r === 'normal') return 'oct_badge-normal-v2';
    //     return 'oct_badge-normal-v2';
    // };

    const getResultBadgeClass = (result) => {
        if (!result) return 'oct_badge-normal-v2';
        const r = result.toLowerCase();
        if (r === 'anomaly') return 'oct_badge-anomaly-v2';
        if (r === 'normal') return 'oct_badge-normal-v2';
        return 'oct_badge-normal-v2';
    };

    // const isConfigAction = String(data.loginStatus || '').toLowerCase() === 'configaction';
    // const configSummary = isConfigAction ? parseConfigActionNote(data.note) : null;
    // const menuOpen = Boolean(anchorEl);
    // const formattedDate = formatMlDetectionDate(data.date);

    // const openDetailsPopup = () => {
    //     if (!isConfigAction) return;
    //     setPopup(getConfigActionImpactPopup(data));
    // };

    // const handleMenuClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const handleMenuClose = () => {
    //     setAnchorEl(null);
    // };

    // const handleViewDetailsClick = () => {
    //     handleMenuClose();
    //     openDetailsPopup();
    // };

    // return (
    //     <tr key={index}>
    //         <td>
    //             <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
    //         </td>
    //         <td title={formattedDate.raw}>
    //             <div className="oct_ml-date-cell">
    //                 <strong className="oct_ml-date-cell__date">{formattedDate.displayDate || "N/A"}</strong>
    //                 {formattedDate.displayTime ? (
    //                     <span className="oct_ml-date-cell__time">{formattedDate.displayTime}</span>
    //                 ) : null}
    //             </div>
    //         </td>
    //         <td><strong>{data.ip}</strong></td>
    //         <td>{normalizeUsername(data.usr)}</td>
    //         <td>
    //             {isConfigAction ? (
    //                 <button
    //                     type="button"
    //                     className="oct_config-action-trigger"
    //                     onClick={openDetailsPopup}
    //                 >
    //                     <div className="oct_config-action-trigger__body">
    //                         <div className="oct_config-action-trigger__header">
    //                             <div>
    //                                 <strong>Config action analysis</strong>
    //                                 <div className="text-muted mb-1">
    //                                     {configSummary?.configFileName ? `Snapshot: ${configSummary.configFileName}` : 'Offline Ollama review completed'}
    //                                     {configSummary?.configChangePk ? ` | Change #${configSummary.configChangePk}` : ''}
    //                                 </div>
    //                             </div>
    //                             <span className="oct_config-action-trigger__cta">
    //                                 Open details
    //                                 <ChevronRight size={16} />
    //                             </span>
    //                         </div>
    //                         <div className="mb-1">
    //                             {configSummary?.vendor ? renderMetaBadge(`Vendor ${configSummary.vendor}`, 'bg-info text-dark') : null}
    //                             {configSummary?.addedCount !== null ? renderMetaBadge(`Added ${configSummary.addedCount}`) : null}
    //                             {configSummary?.removedCount !== null ? renderMetaBadge(`Removed ${configSummary.removedCount}`) : null}
    //                         </div>
    //                         {configSummary?.transitions?.length > 0 && (
    //                             <div className="mb-1">
    //                                 {configSummary.transitions.map((item) => renderMetaBadge(item, 'bg-warning text-dark'))}
    //                             </div>
    //                         )}
    //                         {(configSummary?.recentViolations || configSummary?.validationResults || configSummary?.configSnapshots) && (
    //                             <div className="mb-1">
    //                                 {configSummary.validationResults ? renderMetaBadge(`Validation ${configSummary.validationResults}`) : null}
    //                                 {configSummary.recentViolations ? renderMetaBadge(`Recent violations ${configSummary.recentViolations}`, 'bg-warning text-dark') : null}
    //                                 {configSummary.configSnapshots ? renderMetaBadge(`Snapshots ${configSummary.configSnapshots}`) : null}
    //                             </div>
    //                         )}
    //                         <div className="oct_config-action-trigger__footer">
    //                             {configSummary?.severity?.length > 0 ? (
    //                                 <span><strong>Severity:</strong> {configSummary.severity.join(', ')}</span>
    //                             ) : null}
    //                             {configSummary?.changedSections?.length > 0 ? (
    //                                 <span><strong>Sections:</strong> {configSummary.changedSections.join(', ')}</span>
    //                             ) : null}
    //                             {!configSummary?.severity?.length && !configSummary?.changedSections?.length && configSummary?.diffSnippet ? (
    //                                 <span><strong>Diff signal:</strong> {configSummary.diffSnippet}</span>
    //                             ) : null}
    //                         </div>
    //                     </div>
    //                 </button>
    //             ) : (
    //                 <>This user has logged-in {getLoginCount(data.note)} times today</>
    //             )}
    //         </td>
    //         <td>
    //             <span className={getResultBadgeClass(data.detectionResults)}>
    //                 {data.detectionResults}
    //             </span>
    //         </td>
    //         <td>
    //             <button className="oct_dropdown-trigger-v2" onClick={isConfigAction ? handleMenuClick : undefined}>
    //                 <MoreVertical className="oct_icon" />
    //             </button>
    //             {isConfigAction && (
    //                 <Menu
    //                     className="oct_menu-v2"
    //                     anchorEl={anchorEl}
    //                     keepMounted
    //                     open={menuOpen}
    //                     onClose={handleMenuClose}
    //                 >
    //                     <MenuItem className="oct_menu-item-v2" onClick={handleViewDetailsClick}>
    //                         <Eye className="oct_icon" /> View details & impact
    //                     </MenuItem>
    //                 </Menu>
    //             )}
    //         </td>
    //     </tr>
    // )

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>{data.date}</td>
            <td><strong>{data.ip}</strong></td>
            <td>{normalizeUsername(data.usr)}</td>
            <td>This user has logged-in {getLoginCount(data.note)} times today</td>
            <td>
                <span className={getResultBadgeClass(data.detectionResults)}>
                    {data.detectionResults}
                </span>
            </td>
            <td>
                <button className="oct_dropdown-trigger-v2">
                    <MoreVertical className="oct_icon" />
                </button>
            </td>
        </tr>
    )

}

export default MlDetectionTableRow;
